import { render, staticRenderFns } from "./CardDocuments.vue?vue&type=template&id=117fbe09&scoped=true&"
import script from "./CardDocuments.vue?vue&type=script&lang=ts&"
export * from "./CardDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117fbe09",
  null
  
)

export default component.exports